/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GoogleReviewAiSettingsView = {
    businessType?: string;
    businessCategory?: string;
    businessModel?: GoogleReviewAiSettingsView.businessModel;
    toneOfVoice?: GoogleReviewAiSettingsView.toneOfVoice;
    alwaysInclude?: string;
    neverInclude?: string;
    brandWordingGuidelines?: string | null;
    supportContactGuidelines?: string | null;
    escalationRules?: string | null;
    additionalRules?: string | null;
    exampleGoodReply?: string | null;
};
export namespace GoogleReviewAiSettingsView {
    export enum businessModel {
        OFFLINE = 'offline',
        ONLINE = 'online',
        HYBRID = 'hybrid',
    }
    export enum toneOfVoice {
        FRIENDLY = 'friendly',
        PROFESSIONAL = 'professional',
        CASUAL = 'casual',
        EMPATHETIC = 'empathetic',
        FORMAL = 'formal',
    }
}

